import { gql } from '@apollo/client';

export const GET_TEMPLATE = gql`
  query getTemplate($id: ID) {
    template: getTemplate(id: $id) {
      id

      allFunderRespondents
      allInstitutionRespondents
      allServiceProviderRespondents
      createdAt
      description
      editable
      name
      published
      submissions
      updatedAt
      version

      administration {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
      creator {
        id
        name
      }
      funderRespondents {
        id
        name
      }
      institutionRespondents {
        id
        name
      }
      modifiedBy {
        id
        firstName
        lastName
      }
      owner {
        id
        isFunder
        isInstitution
        isServiceProvider
        funder {
          id
          name
        }
        institution {
          id
          name
        }
        serviceProvider {
          id
          name
        }
      }
      questions {
        pages {
          elements {
            type
            name
            elements {
              id
              name
              isRequired

              category
              description
              hideNumber
              choices
              questionNumber
              readOnly
              requirePhotos
              title
              text
              type
              visible
              visibleIf
            }
            title
          }
          name
          title
        }
        triggers {
          expression
          fromName
          setToName
          setValue
          type
        }
        showProgressBar
        showQuestionNumbers
        title
        templateId
      }
      serviceProviderRespondents {
        id
        name
      }
      tags {
        id
        name
      }
      type {
        id
        name
      }
    }
  }
`;
